module.exports = __webpack_public_path__ + "img/1764125066275-KUE MASUBAH MAMA 3N.jpg.1fc21c9f.webp";